import * as types from '../../../../constants/ActionNameConstants';

export const myMetricsRequest = (payload) => ({
  type: types.GET_MY_METRICS_LIST_REQUEST,
  payload,
});

export const myMetricsSuccess = (payload) => ({
  type: types.GET_MY_METRICS_LIST_SUCCESS,
  payload,
});

export const myMetricsFailure = (error) => ({
  type: types.GET_MY_METRICS_LIST_FAILED,
  error,
});

export const resetMyMetricsData = () => {
  return {
    type: types.RESET_MY_METRICS_LIST_DATA,
  };
};
